<template>
  <v-dialog
    v-model="value.show"
    max-width="600"
  >
    <v-card v-if="value.data && value.data.errorDetails && value.data.errorDetails.length">
      <v-card-title>
        <v-col
          cols="10"
          class="red--text"
        >
          SOUBOR OBSAHUJE NESPRÁVNÁ DATA
        </v-col>

        <v-col class="text-right">
          <v-btn
            depressed
            icon
            @click="value.show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>

      <v-card-text>
        <v-btn
          depressed
          outlined
          height="40px"
          color="primary"
          light
          :loading="value.fileDownloadLoading"
          @click.prevent="downloadFileWithErrors"
        >
          <v-icon
            class="mr-2"
            small
          >mdi-download</v-icon>
          Stáhnout protokol chyb
        </v-btn>
      </v-card-text>
    </v-card>

    <v-card v-else>
      <v-card-title>
        <v-row>
          <v-col cols="10">
            SOUBOR BYL PŘIJAT
          </v-col>

          <v-col class="text-right">
            <v-btn
              depressed
              icon
              @click="value.show = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="font-weight-bold">
        Průběh zpracování můžete sledovat v požadavku číslo
        <router-link :to="{
            name: 'requests.detail',
            params: {
              id: value.data.id,
            },
          }">{{ value.data.id }}</router-link>.
      </v-card-text>

      <v-card-text class="font-weight-bold">
        Pokud bude požadavek zpracován s výhradou, obsahuje pravděpodobně chybná data.
        Doporučujeme ověřit správnost dat v souboru s výsledky kontroly.
        Chybná data prosím opravte a založte pro ně nový požadavek
        (v opačném případě nebudou zpracována).
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { downloadFile } from '@/components/mixins/downloadFile';

export default {
  name: 'BulkInstallationDialog',
  mixins: [downloadFile],
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  methods: {
    downloadFileWithErrors(event) {
      this.value.fileDownloadLoading = true;
      this.downloadFile(event, `requests/files/${this.value.data.errorDetails[0].excelFileUuid}`).finally(() => {
        this.value.fileDownloadLoading = false;
      });
    },
  },
};
</script>
